<template>
    <div class="platforms">
        <b-container class="bv-example-row bv-example-row-flex-cols">
            <b-row align-v="center" align-h="center" class="h-100vh">
                <b-col align-self="center" md="8">
                    <b-row align-h="center">
                        <b-col md="4" v-for="(platform, index) in platforms" class="justify-content-center align-items-end d-flex" :key="index">
                            <div class="item text-center">
                                <a :href="platform.reference_value_link" target="_blank">
                                    <img :src="platform.reference_value_image" alt="" class="mb-2">
                                    <p>{{platform.reference_value_text}}</p>
                                </a>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    export default {
        name: 'Platform',
        components: {

        },
        data () {
            return {
                platforms:[],
            }
        },
        computed: {

        },
        watch: {

        },
        async created() {
            this.getPlatforms();
        },
        mounted: async function() {

        },
        updated: async function() {

        },
        methods:{
            getPlatforms(){
                let filter = {reference_type: "Source Application"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "reference_value_int",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.platforms = response.items;
                    })
            }
        }
    }
</script>
